import script from "./InvoiceHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceHistory.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceHistory.vue?vue&type=style&index=0&id=6f4e3b0a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f4e3b0a"]])

export default __exports__